// Import libraries
import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import PropTypes from "prop-types";

// Main Modal View
export const SuccessCancelOrderModal = ({ open, handleClose, orderId }) => {
  // Modal View
  return (
    // Modal Dialog
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">
        {`The Order ${orderId} was canceled`}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          You will receive a confirmation email.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          autoFocus
          onClick={handleClose}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SuccessCancelOrderModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  orderId: PropTypes.string,
};
